/**
 * Contact project wizard + HubSpot booking modal
 */
(function contactProjectFrontend($, window) {
	$(document).on('cms.ready', ready);

	var bookingBound = false;

	function ready() {
		var logged_in = $('body.logged-in').length;

		$(document).on('cms.intersect cms.add', '.sectionContactProject', function (evt, entry, $elm) {
			setupSection(0, $elm || entry);
			bindBookingOnce();
		});

		$('.sectionContactProject').each(setupSection);
		bindBookingOnce();

		if (logged_in && !bookingBound) {
			var tries = 0;
			var timer = setInterval(function () {
				$('.sectionContactProject').each(setupSection);
				bindBookingOnce();
				if (bookingBound || ++tries > 40) clearInterval(timer);
			}, 250);
		}
	}

	function lockHover($btn) {
		if (!$btn || !$btn.length) return;
		$btn.addClass('is-hover-lock');
		$btn.off('.hoverlock').on('pointerleave.hoverlock mouseleave.hoverlock', function () {
			$btn.removeClass('is-hover-lock').off('.hoverlock');
		});
	}

	function apiUrl(path, query) {
		var base = (window.Contenda && Contenda.basepath) || '/';
		var url = base + 'api/hubspot/' + path;
		var params = query || {};
		if (window.Contenda && Contenda.formtok) params.formtok = Contenda.formtok;
		var keys = Object.keys(params).filter(function (key) { return params[key] != null && params[key] !== ''; });
		if (!keys.length) return url;
		return url + '?' + keys.map(function (key) {
			return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
		}).join('&');
	}

	function validEmail(value) {
		return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
	}

	function setupSection(i, elm) {
		var $elm = $(elm);
		if ($elm.data('contact-project-ready')) return;
		$elm.data('contact-project-ready', true);

		if (window.Contenda && Contenda.company) {
			Contenda.company.fillContact($elm);
		}

		setupWizard($elm);
		bindBookingOnce();
	}

	function setupWizard($root) {
		var $form = $root.find('.js-project-form');
		if (!$form.length) return;

		var $steps = $form.find('.contact-project__step');
		var $btnNext = $form.find('.js-btn-next');
		var $btnBack = $form.find('.js-btn-back');
		var $stepLabel = $form.find('.js-step-label');
		var $micro = $form.find('.js-wizard-micro');
		var $nav = $form.find('.js-form-nav');
		var $error = $form.find('.js-form-error');
		var $success = $form.find('.js-form-success');
		var current = 1;
		var submitted = false;
		var data = { type: null, budget: null, timeline: null };
		var chosenFiles = [];
		var $fileInput = $form.find('.js-project-files');
		var $fileDrop = $form.find('.js-files-drop');
		var $fileList = $form.find('.js-files-list');
		var $fileNote = $form.find('.js-files-note');
		var $fileLabel = $form.find('.js-files-label');
		var FILE_MAX = 5;
		var FILE_MAX_BYTES = 50 * 1024 * 1024;
		var FILE_TYPES = /\.(pdf|docx?|html?|png|jpe?g|webp|gif|mp4|webm)$/i;

		function fieldFor(step) {
			return ['type', 'budget', 'timeline'][step - 1] || null;
		}

		function updateUI() {
			$steps.each(function () {
				$(this).toggleClass('is-active', +$(this).data('step') === current);
			});
			$form.find('.contact-project__segs span').each(function () {
				$(this).toggleClass('is-done', +$(this).data('seg') <= current);
			});
			$stepLabel.html('Trin <em>' + current + '</em> af <em>4</em>');
			$btnBack.prop('hidden', current === 1);
			$micro.prop('hidden', current !== 1);
			if (current === 4) {
				$btnNext.text('Send besked').prop('disabled', false);
			} else {
				$btnNext.text('Næste').prop('disabled', !data[fieldFor(current)]);
			}
		}

		$form.find('.contact-project__chips').on('click', function (e) {
			var $chip = $(e.target).closest('.contact-project__chip');
			if (!$chip.length) return;
			var $group = $(this);
			$group.find('.contact-project__chip').attr('aria-pressed', 'false');
			$chip.attr('aria-pressed', 'true');
			data[$group.data('field')] = $chip.text().trim();
			$btnNext.prop('disabled', false);
			var st = current;
			setTimeout(function () {
				if (current === st && current < 4 && data[fieldFor(current)]) go(current + 1);
			}, 280);
		});

		function go(n) {
			current = Math.min(Math.max(n, 1), 4);
			updateUI();
		}

		$btnBack.on('click', function () {
			go(current - 1);
			$btnBack.trigger('blur');
			lockHover($btnBack);
		});
		$btnNext.on('click', function () {
			if (current < 4) {
				if (data[fieldFor(current)]) {
					go(current + 1);
					$btnNext.trigger('blur');
					lockHover($btnNext);
				}
				return;
			}
			submitForm();
		});

		function renderFiles() {
			if ($fileLabel.length) {
				$fileLabel.text(chosenFiles.length ? 'Tilføj flere filer' : 'Tilføj filer');
			}
			if (!$fileList.length) return;
			$fileList.empty().prop('hidden', !chosenFiles.length);
			chosenFiles.forEach(function (file, index) {
				var $btn = $('<button type="button" class="trigger contact-project__file-chip"></button>')
					.attr('aria-label', 'Fjern ' + file.name)
					.on('click', function (e) {
						e.preventDefault();
						chosenFiles.splice(index, 1);
						renderFiles();
					});
				$('<span class="contact-project__file-chip-x" aria-hidden="true"></span>')
					.html('<svg viewBox="0 0 16 16" fill="none"><path d="M4 4l8 8M12 4 4 12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>')
					.appendTo($btn);
				$('<span></span>').text(file.name).appendTo($btn);
				$fileList.append($('<li></li>').append($btn));
			});
		}

		function addFiles(list) {
			var note = '';
			Array.prototype.forEach.call(list || [], function (file) {
				if (chosenFiles.length >= FILE_MAX) {
					note = 'Du kan højst vedhæfte ' + FILE_MAX + ' filer.';
					return;
				}
				if (!FILE_TYPES.test(file.name)) {
					note = 'Den filtype kan ikke vedhæftes.';
					return;
				}
				if (file.size > FILE_MAX_BYTES) {
					note = 'Filen er for stor (max 50 MB).';
					return;
				}
				var exists = chosenFiles.some(function (item) {
					return item.name === file.name && item.size === file.size;
				});
				if (!exists) chosenFiles.push(file);
			});
			if ($fileInput.length) $fileInput.val('');
			renderFiles();
			if ($fileNote.length) {
				$fileNote.text(note).prop('hidden', !note);
			}
		}

		function filesToPayload() {
			var deferred = $.Deferred();
			if (!chosenFiles.length) {
				deferred.resolve([]);
				return deferred.promise();
			}
			var out = [];
			var left = chosenFiles.length;
			chosenFiles.forEach(function (file) {
				var reader = new FileReader();
				reader.onload = function () {
					var result = String(reader.result || '');
					var comma = result.indexOf(',');
					out.push({
						name: file.name,
						type: file.type || 'application/octet-stream',
						data: comma >= 0 ? result.slice(comma + 1) : result
					});
					if (--left === 0) deferred.resolve(out);
				};
				reader.onerror = function () { deferred.reject(); };
				reader.readAsDataURL(file);
			});
			return deferred.promise();
		}

		$fileInput.on('change', function () {
			addFiles(this.files);
			this.value = '';
		});
		$fileDrop.on('dragover dragenter', function (e) {
			e.preventDefault();
			$fileDrop.addClass('is-drag');
		});
		$fileDrop.on('dragleave drop', function (e) {
			e.preventDefault();
			$fileDrop.removeClass('is-drag');
			if (e.type === 'drop' && e.originalEvent.dataTransfer) {
				addFiles(e.originalEvent.dataTransfer.files);
			}
		});

		function showSuccess() {
			submitted = true;
			$steps.removeClass('is-active');
			$nav.hide();
			// Both are needed: [hidden] keeps it out of the flow until now, and
			// .is-visible is what the stylesheet actually switches display on.
			$success.prop('hidden', false).addClass('is-visible');
		}

		var FIELD_MESSAGES = {
			firstname: 'Indtast mindst 2 tegn.',
			lastname: 'Indtast mindst 2 tegn.',
			email: 'Indtast en gyldig email-adresse.',
			phone: 'Indtast venligst et gyldigt telefonnummer.',
			message: 'Dette felt er påkrævet.'
		};

		function validPhone(value) {
			return /^[+\d][\d\s()-]{5,}$/.test(value);
		}

		function setFieldError($input, message) {
			var id = $input.attr('aria-describedby');
			var $err = id ? $form.find('#' + id) : $();
			$input.toggleClass('is-invalid', !!message).attr('aria-invalid', !!message);
			$err.text(message || '').prop('hidden', !message);
		}

		function validateField($input) {
			var name = $input.attr('name');
			var value = $input.val().trim();
			var valid = value !== '';
			if (valid && name === 'email') valid = validEmail(value);
			if (valid && name === 'phone') valid = validPhone(value);
			if (valid && (name === 'firstname' || name === 'lastname')) valid = value.length >= 2;
			setFieldError($input, valid ? '' : (FIELD_MESSAGES[name] || 'Udfyld venligst dette felt.'));
			return valid;
		}

		$form.find('.contact-project__fields [required]').on('input blur', function () {
			validateField($(this));
		});

		function submitForm() {
			var ok = true;
			$form.find('.contact-project__fields [required]').each(function () {
				if (!validateField($(this))) ok = false;
			});
			if (!ok) {
				$form.find('.is-invalid').first().trigger('focus');
				return;
			}

			var payload = {
				type: data.type,
				budget: data.budget,
				timeline: data.timeline,
				firstname: $form.find('[name=firstname]').val().trim(),
				lastname: $form.find('[name=lastname]').val().trim(),
				email: $form.find('[name=email]').val().trim(),
				phone: $form.find('[name=phone]').val().trim(),
				message: $form.find('[name=message]').val().trim(),
				pageUri: window.location.href,
				pageName: document.title,
				formtok: window.Contenda && Contenda.formtok
			};

			$error.prop('hidden', true);
			$btnNext.prop('disabled', true).text('Sender …');

			filesToPayload().done(function (files) {
				if (files && files.length) payload.files = files;
				$.ajax({
					url: apiUrl('form'),
					method: 'POST',
					contentType: 'application/json',
					data: JSON.stringify(payload)
				}).done(function () {
					showSuccess();
				}).fail(function () {
					$btnNext.prop('disabled', false).text('Send besked');
					$error.prop('hidden', false);
				});
			}).fail(function () {
				$btnNext.prop('disabled', false).text('Send besked');
				$error.prop('hidden', false);
			});
		}

		updateUI();
	}

	function bindBookingOnce() {
		var $modal = $('.js-booking-modal').last();
		var $pill = $('.js-booking-pill').last();
		if (!$modal.length) return false;

		if ($modal.parent()[0] !== document.body) $modal.appendTo(document.body);
		if ($pill.length && $pill.parent()[0] !== document.body) $pill.appendTo(document.body);
		$('body > .js-booking-modal').slice(0, -1).remove();
		$('body > .js-booking-pill').slice(0, -1).remove();
		$modal = $('body > .js-booking-modal').last();
		$pill = $('body > .js-booking-pill').last();

		if (bookingBound) return true;
		bookingBound = true;
		var bstate = { step: 1, monthOffset: 0, date: null, dateLabel: '', slot: null };
		var daFull = new Intl.DateTimeFormat('da-DK', { weekday: 'long' });
		var daMonth = new Intl.DateTimeFormat('da-DK', { month: 'long' });

		function cap(s) {
			return s.charAt(0).toUpperCase() + s.slice(1);
		}

		function isoLocal(d) {
			return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
		}

		function openDays() {
			if (window.Contenda && Contenda.company) return Contenda.company.openDays();
			return [1, 2, 3, 4, 5];
		}

		function fetchSlots(dateObj) {
			return $.ajax({
				url: apiUrl('slots', {
					date: isoLocal(dateObj),
					tz: 'Europe/Copenhagen'
				})
			}).then(function (json) {
				return (json && json.slots) ? json.slots : [];
			});
		}

		function monthsList() {
			var out = [];
			var now = new Date();
			for (var i = 0; i < 4; i++) {
				var d = new Date(now.getFullYear(), now.getMonth() + i, 1);
				out.push({ offset: i, label: cap(daMonth.format(d)), year: d.getFullYear(), month: d.getMonth() });
			}
			return out;
		}

		function businessDaysIn(year, month) {
			var allowed = openDays();
			var out = [];
			var now = new Date();
			var start = (year === now.getFullYear() && month === now.getMonth())
				? new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1)
				: new Date(year, month, 1);
			for (var d = new Date(start); d.getMonth() === month; d.setDate(d.getDate() + 1)) {
				if (allowed.indexOf(d.getDay()) !== -1) out.push(new Date(d));
			}
			return out;
		}

		function renderMonths() {
			var $host = $modal.find('.js-month-chips');
			$host.empty();
			monthsList().forEach(function (m) {
				var $b = $('<button type="button" class="trigger contact-booking__chip"></button>')
					.attr('aria-pressed', m.offset === bstate.monthOffset ? 'true' : 'false')
					.text(m.label)
					.on('click', function () {
						bstate.monthOffset = m.offset;
						bstate.date = null;
						bstate.slot = null;
						renderMonths();
						renderDates();
						renderSlots([]);
						syncFoot();
					});
				$host.append($b);
			});
		}

		function renderDates() {
			var $host = $modal.find('.js-date-cards');
			$host.empty();
			var m = monthsList()[bstate.monthOffset];
			var days = businessDaysIn(m.year, m.month);
			if (!days.length) {
				$host.html('<p>Ingen ledige dage i denne måned — vælg næste måned.</p>');
				return;
			}
			days.forEach(function (d) {
				var label = d.getDate() + '. ' + cap(daMonth.format(d));
				var $b = $('<button type="button" class="trigger contact-booking__date"></button>')
					.attr('aria-pressed', 'false')
					.html('<span>' + label + '</span><strong>' + cap(daFull.format(d)) + '</strong>')
					.on('click', function () {
						$host.find('.contact-booking__date').attr('aria-pressed', 'false');
						$b.attr('aria-pressed', 'true');
						bstate.date = d;
						bstate.dateLabel = cap(daFull.format(d)) + ' d. ' + label;
						bstate.slot = null;
						$modal.find('.js-slot-grid').html('<p>Henter ledige tider …</p>');
						fetchSlots(d).done(function (slots) {
							if (bstate.date === d) renderSlots(slots);
						}).fail(function () {
							if (bstate.date === d) {
								$modal.find('.js-slot-grid').html(
									'<p>Ledige tider kunne ikke hentes. Prøv igen — eller ring, så finder vi en tid.</p>'
								);
							}
						});
						syncFoot();
					});
				$host.append($b);
			});
		}

		function renderSlots(slots) {
			var $host = $modal.find('.js-slot-grid');
			$host.empty();
			if (!bstate.date) {
				$host.html('<p>Vælg en dato for at se ledige tider.</p>');
				return;
			}
			if (!slots.length) {
				$host.html('<p>Ingen ledige tider denne dag. Prøv en anden dato — eller ring til os.</p>');
				return;
			}
			slots.forEach(function (t) {
				var $b = $('<button type="button" class="trigger contact-booking__slot"></button>')
					.text(t)
					.attr('aria-pressed', 'false')
					.on('click', function () {
						$host.find('.contact-booking__slot').attr('aria-pressed', 'false');
						$b.attr('aria-pressed', 'true');
						bstate.slot = t;
						syncFoot();
					});
				$host.append($b);
			});
		}

		function bGo(step) {
			bstate.step = step;
			$modal.find('.contact-booking__step').each(function () {
				$(this).toggleClass('is-active', +$(this).data('bstep') === step);
			});
			if (step === 2) {
				$modal.find('.js-booking-summary').text(bstate.dateLabel + ' · kl. ' + bstate.slot);
			}
			syncFoot();
			$modal.find('.contact-booking__body').scrollTop(0);
		}

		function syncFoot() {
			var $back = $modal.find('.js-booking-back');
			var $next = $modal.find('.js-booking-next');
			var $foot = $modal.find('.contact-booking__foot');
			if (bstate.step === 1) {
				$foot.show();
				$back.text('Luk');
				$next.text('Næste').prop('disabled', !(bstate.date && bstate.slot));
			} else if (bstate.step === 2) {
				$foot.show();
				$back.text('Tilbage');
				$next.text('Book mødet').prop('disabled', false);
			} else {
				$foot.hide();
			}
		}

		function submitBooking() {
			var $first = $modal.find('.js-b-firstname');
			var $last = $modal.find('.js-b-lastname');
			var $email = $modal.find('.js-b-email');
			var $phone = $modal.find('.js-b-phone');
			var $company = $modal.find('.js-b-company');
			var $msg = $modal.find('.js-b-msg');
			var ok = true;
			[$first, $last, $email, $phone, $company, $msg].forEach(function ($input) {
				var valid = $input.val().trim() !== '';
				if ($input.is('[type=email]')) valid = valid && validEmail($input.val().trim());
				$input.toggleClass('is-invalid', !valid);
				if (!valid) ok = false;
			});
			if (!ok) {
				$modal.find('.is-invalid').first().trigger('focus');
				return;
			}

			var $err = $modal.find('.js-booking-error');
			var $next = $modal.find('.js-booking-next');
			$err.prop('hidden', true);
			$next.prop('disabled', true).text('Booker …');

			var payload = {
				date: bstate.date ? isoLocal(bstate.date) : '',
				slot: bstate.slot,
				firstname: $first.val().trim(),
				lastname: $last.val().trim(),
				email: $email.val().trim(),
				phone: $phone.val().trim(),
				company: $company.val().trim(),
				message: $msg.val().trim(),
				formtok: window.Contenda && Contenda.formtok
			};

			$.ajax({
				url: apiUrl('book'),
				method: 'POST',
				contentType: 'application/json',
				data: JSON.stringify(payload)
			}).done(function () {
				$modal.find('.js-booking-confirm').text(
					'Vi har reserveret ' + bstate.dateLabel.toLowerCase() + ' kl. ' + bstate.slot +
					'. Du får en bekræftelse på ' + payload.email + ' med et kalender-link.'
				);
				bGo(3);
			}).fail(function () {
				$next.prop('disabled', false).text('Book mødet');
				$err.prop('hidden', false);
			});
		}

		var closeTimer = null;

		function openBooking() {
			bstate = { step: 1, monthOffset: 0, date: null, dateLabel: '', slot: null };
			if (closeTimer) {
				clearTimeout(closeTimer);
				closeTimer = null;
			}
			$modal.prop('hidden', false);
			$('body').addClass('contact-booking-open');
			renderMonths();
			renderDates();
			renderSlots([]);
			bGo(1);
			$modal[0].offsetWidth;
			$modal.addClass('is-open');
			syncChatOffset();
		}

		function closeBooking() {
			$modal.removeClass('is-open');
			var finish = function () {
				if (closeTimer) {
					clearTimeout(closeTimer);
					closeTimer = null;
				}
				$modal.prop('hidden', true);
				$('body').removeClass('contact-booking-open');
				syncChatOffset();
			};
			var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
			if (reduce) {
				finish();
				return;
			}
			closeTimer = setTimeout(finish, 420);
		}

		$(document).on('click', '.js-open-booking, .js-booking-pill', function (e) {
			e.preventDefault();
			openBooking();
		});
		$modal.on('click', '.js-close-booking', closeBooking);
		$modal.on('click', '.js-booking-back', function () {
			if (bstate.step === 1) closeBooking();
			else {
				bGo(1);
				lockHover($(this));
			}
		});
		$modal.on('click', '.js-booking-next', function () {
			if (bstate.step === 1 && bstate.date && bstate.slot) {
				bGo(2);
				lockHover($(this));
			} else if (bstate.step === 2) submitBooking();
		});
		$(document).on('keydown', function (e) {
			if (e.key === 'Escape' && !$modal.prop('hidden')) closeBooking();
		});

		/* The pill ships hidden so it cannot flash before this runs, but from here
		   on it stays in the layout and fades via .is-on — toggling [hidden] would
		   skip the transition and make it pop in. */
		if ($pill.length) $pill.prop('hidden', false);

		function scrollY() {
			if (typeof window.pageYOffset === 'number') return window.pageYOffset;
			return (document.scrollingElement
				|| document.documentElement
				|| document.body).scrollTop || 0;
		}

		function viewportBottom() {
			if (window.visualViewport) {
				return window.visualViewport.offsetTop + window.visualViewport.height;
			}
			return window.innerHeight || document.documentElement.clientHeight || 0;
		}

		function haloTop() {
			var halo = document.querySelector('.contact-project__halo');
			if (!halo) return null;
			return halo.getBoundingClientRect().top;
		}

		function chatWidget() {
			return document.querySelector('#hubspot-messages-iframe-container');
		}

		function pillRestOffset() {
			var el = $pill[0];
			var styles = window.getComputedStyle(el);
			var bottom = parseFloat(styles.bottom) || 0;
			return Math.max(0, Math.round(el.offsetHeight + bottom + 12));
		}

		function syncChatOffset() {
			var pillOn = $pill.length && $pill.hasClass('is-on') && !$pill.prop('hidden')
				&& !$('body').hasClass('contact-booking-open');
			var offset = pillOn ? pillRestOffset() : 0;
			document.documentElement.style.setProperty('--hs-chat-offset', offset ? offset + 'px' : '0px');
			document.body.classList.toggle('has-booking-pill', !!offset);
			var hs = chatWidget();
			if (hs) {
				if (offset) hs.style.setProperty('bottom', offset + 'px', 'important');
				else hs.style.removeProperty('bottom');
			}
		}

		var pillRaf = 0;
		function updatePill() {
			if (pillRaf) return;
			pillRaf = window.requestAnimationFrame(function () {
				pillRaf = 0;
				if (!$pill.length) return;
				var top = haloTop();
				var show = top == null ? scrollY() > 80 : top <= viewportBottom();
				$pill.toggleClass('is-on', show);
				syncChatOffset();
			});
		}

		var scrollOpts = { passive: true, capture: true };
		window.addEventListener('scroll', updatePill, scrollOpts);
		document.addEventListener('scroll', updatePill, scrollOpts);
		$(window).on('resize orientationchange', updatePill);
		if (window.visualViewport) {
			window.visualViewport.addEventListener('resize', updatePill);
			window.visualViewport.addEventListener('scroll', updatePill);
		}
		$('.md-content, #main_body, #content, #main').each(function () {
			this.addEventListener('scroll', updatePill, scrollOpts);
		});
		if (window.ResizeObserver) {
			var haloEl = document.querySelector('.contact-project__halo');
			var gridEl = document.querySelector('.contact-project__grid');
			var ro = new ResizeObserver(updatePill);
			if (haloEl) ro.observe(haloEl);
			if (gridEl) ro.observe(gridEl);
		}
		if (window.MutationObserver) {
			var chatObs = new MutationObserver(function () {
				if (chatWidget()) {
					syncChatOffset();
					chatObs.disconnect();
				}
			});
			chatObs.observe(document.body, { childList: true, subtree: true });
		}
		updatePill();
		return true;
	}
})(jQuery, window);
